var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { colors as themeColors } from "../themes/nectar";

export var sizes = {
  XXS: "xxs",
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl",
  XXL: "xxl",
  NONE: "none"
};

export var colors = Object.keys(themeColors).reduce(function (object, key) {
  var _extends2;

  return _extends({}, object, (_extends2 = {}, _extends2[key.toUpperCase()] = key, _extends2));
}, {});

export var textTransformTypes = {
  NONE: "none",
  LOWERCASE: "lowercase",
  UPPERCASE: "uppercase",
  CAPITALIZE: "capitalize"
};